import { addDoc, arrayUnion, collection, doc, updateDoc } from "firebase/firestore";
import { limit as liteLimit, orderBy as liteOrderBy, where as liteWhere } from "firebase/firestore/lite";
import db from "../Firebase";
import { Messaging } from "../../models/Messaging.tsx";
import { Users } from "../../models/User.tsx";
import { getLiteQueryDocs } from "../../helpers/firestoreLiteQuery.ts";


export async function messaging(newMessage: Messaging): Promise<string> {
  try {
    const messagingRef = collection(db, 'messaging');
    const docRef = await addDoc(messagingRef, newMessage);
    return docRef.id;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export async function getAgentOfPlayer(userName: string): Promise<string | null> {
  try {
    const docs = await getLiteQueryDocs('users', [
      liteWhere('userName', '==', userName),
    ]);

    if (docs.length === 0) {
      console.error('not found user');
      return null;
    }

    const playerData = docs[0].data() as Users;

    if (playerData.parent) {
      return playerData.parent;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}


export async function showMessaging(userId: string): Promise<Messaging[]> {
  try {
    const docs = await getLiteQueryDocs("messaging", [
      liteWhere("recipientUsers", "array-contains", userId),
    ]);

    const messages: Messaging[] = [];
    docs.forEach((docSnap) => {
      const messageData = docSnap.data() as Messaging;
      if (!messageData.deletedBy?.includes(userId)) {
        messages.push({
          ...messageData,
          id: docSnap.id
        });
      }
    });

    return messages;
  } catch (error) {
    console.error(error);
    throw new Error("Error fetching messages");
  }
}

export async function showMessagingSent(userId: string): Promise<Messaging[]> {
  try {
    const docs = await getLiteQueryDocs('messaging', [
      liteWhere("senderUser", "==", userId),
    ]);

    const messages: Messaging[] = [];
    docs.forEach((docSnap) => {
      const messageData = docSnap.data() as Messaging;
      if (!messageData.deletedBy?.includes(userId)) {
        messages.push({
          ...messageData,
          id: docSnap.id
        });
      }
    });

    return messages;
  } catch (error) {
    console.error(error);
    throw new Error("Error fetching sent messages");
  }
}

export async function deleteMessageForUser(messageId: string, userId: string): Promise<void> {
  try {
    const messageDoc = doc(db, "messaging", messageId);
    await updateDoc(messageDoc, {
      deletedBy: arrayUnion(userId)
    });
  } catch (error) {
    console.error(error);
    throw new Error("Error deleting message for user");
  }
}

export function isMessageUnread(message: Messaging, userId: string): boolean {
  return !message.deletedBy?.includes(userId) && !message.readBy?.includes(userId);
}

export async function fetchUnreadMessageCount(userId: string): Promise<number> {
  try {
    const docs = await getLiteQueryDocs("messaging", [
      liteWhere("recipientUsers", "array-contains", userId),
      liteOrderBy("createDate", "desc"),
      liteLimit(50),
    ]);

    let count = 0;
    docs.forEach((docSnap) => {
      const messageData = docSnap.data() as Messaging;
      if (isMessageUnread(messageData, userId)) {
        count++;
      }
    });
    return count;
  } catch (error) {
    console.error("Error fetching unread messages:", error);
    return 0;
  }
}

export async function markMessageAsRead(messageId: string, userId: string): Promise<void> {
  try {
    const messageDoc = doc(db, "messaging", messageId);
    await updateDoc(messageDoc, {
      readBy: arrayUnion(userId)
    });
  } catch (error) {
    console.error(error);
    throw new Error("Error marking message as read");
  }
}



